import type { ReactNode } from "react";

/**
 * A section of a one-page settings screen (the tenant account page, the console profile): its
 * heading over its content, the sections split by hairlines in a `divide-y` column.
 */
export function PageSection(props: { id: string; title: string; children: ReactNode }) {
  return (
    <section
      id={props.id}
      aria-labelledby={`${props.id}-heading`}
      className="flex scroll-mt-6 flex-col gap-5 py-8 first:pt-0"
    >
      <h2 id={`${props.id}-heading`} className="text-base font-semibold text-fg">
        {props.title}
      </h2>
      {props.children}
    </section>
  );
}

/** A block's heading inside a section (a password, an authenticator, passkeys). */
export function SubHeading({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <h3 id={id} className="text-sm font-semibold text-fg">
      {children}
    </h3>
  );
}
